import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { Trans } from 'react-i18next';
import { ConfirmationModalWithTextBox } from '../../../components/ConfirmationModalWithTextBox';

interface IDeleteDatasetConfirmationModalProps {
  showDatasetDeleteConfirmationModal: boolean;
  datasetDeleteConfirmationText: string;
  onDatasetDeleteConfirm: () => Promise<void>;
  onDeleteDatasetCancel: (datasetId: string) => void;
}

export const DeleteDatasetConfirmationModal = observer((props: IDeleteDatasetConfirmationModalProps): ReactElement => {
  const { t } = useTranslator();

  const onCancel = (): void => {
    props.onDeleteDatasetCancel('');
  };

  const question = (
    <Trans
      i18nKey='delete_dataset_confirmation_header'
      values={{ name: props.datasetDeleteConfirmationText }}
      components={{ b: <b className='persist-reduntant-spaces' /> }}
    />
  );

  return (
    <ConfirmationModalWithTextBox
      confirmationHeader={t('delete_dataset_header')}
      confirmationQuestion={t('delete_dataset_confirmation_body')}
      confirmationTextHeader={question}
      confirmationText={props.datasetDeleteConfirmationText}
      onCancel={onCancel}
      onConfirm={props.onDatasetDeleteConfirm}
      showModal={props.showDatasetDeleteConfirmationModal}
      confirmationYes={t('delete')}
      loaderKey='delete'
    />
  );
});
